import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import MainUI from "./UIcomponents/MainUI";

// Initialize GA4 - Replace with your actual Measurement ID
const GA_MEASUREMENT_ID = "G-XVP81X5WCB";

// Only initialize GA if not on localhost to keep analytics clean
if (!window.location.hostname.includes("localhost") && !window.location.hostname.includes("127.0.0.1")) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Only send pageview if GA is initialized
    if (ReactGA.isInitialized) {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
    setTimeout(() => {
      document.dispatchEvent(new Event("render-event"));
    }, 1500);
  }, [location]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <PageTracker />
      <Routes>
        <Route path="/*" element={<MainUI />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
